// @flow

import type {AllVideosModel} from './Videos';

const VIDEOS_LOADING = 'VIDEOS_LOADING';
const VIDEOS_LOADED = 'VIDEOS_LOADED';
const VIDEOS_ERROR = 'VIDEOS_ERROR';

export type VideosLoadingEvent = {|
  type: typeof VIDEOS_LOADING,
  payload: {},
|};

export const videosLoading = (): VideosLoadingEvent => ({
  type: VIDEOS_LOADING,
  payload: {},
});

export type VideosLoadedEvent = {|
  type: typeof VIDEOS_LOADED,
  payload: {videos: AllVideosModel},
|};

export const videosLoaded = (videos: AllVideosModel): VideosLoadedEvent => ({
  type: VIDEOS_LOADED,
  payload: {videos},
});

export type VideosErrorEvent = {|
  type: typeof VIDEOS_ERROR,
  payload: {error: any},
|};

export const videosError = (error: any): VideosErrorEvent => ({
  type: VIDEOS_ERROR,
  payload: {error},
});

export type VideosEvent =
  | VideosLoadingEvent
  | VideosLoadedEvent
  | VideosErrorEvent;

export type VideosReducerState = {|
  allVideos?: AllVideosModel,
  isLoading: boolean,
  error?: any,
|};

export const VideosReducer = (
  state: VideosReducerState,
  event: VideosEvent,
): VideosReducerState => {
  switch (event.type) {
    case VIDEOS_LOADING:
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case VIDEOS_LOADED:
      return {
        ...state,
        isLoading: false,
        error: null,
        allVideos: event.payload.videos,
      };
    case VIDEOS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: event.payload.error,
      };
    default:
      throw new Error(`Unknown video event ${event.type}`);
  }
};
